import { UserProfile } from '../../../entities/user/userprofile';
import { DbUserProfileRepository } from '../db/db-user-profile-repository';

interface ICacheItem {
  userProfiles: UserProfile[];
  cacheTime: Date;
}

interface IUserProfileCache {
  [beltNumber: string]: ICacheItem;
}

const USER_CACHE_TIMEOUT = 4000;

export class CachedByBeltNumberUserRepository extends DbUserProfileRepository {
  private cache: IUserProfileCache = {};

  public async getByStudioBeltNumber(
    beltNumber: string,
    now: Date = new Date(),
    cacheTimeout = USER_CACHE_TIMEOUT,
  ): Promise<UserProfile[]> {
    const cachedItem = this.cache[beltNumber];
    if (!cachedItem) {
      return await this.setCacheToUser(beltNumber, now);
    }

    const shouldRetryFindingUserByBelt = now.getTime() - cachedItem.cacheTime.getTime() >= cacheTimeout;
    if (shouldRetryFindingUserByBelt) {
      return await this.setCacheToUser(beltNumber, now);
    }

    return this.cache[beltNumber].userProfiles;
  }

  public reset() {
    this.cache = {};
  }

  private async setCacheToUser(beltNumber: string, now: Date) {
    const userProfiles = await super.getByStudioBeltNumber(beltNumber);
    for (const userProfile of userProfiles) {
      userProfile.setAgeFromDateOfBirth();
    }

    const cachedItem = {
      userProfiles,
      cacheTime: now,
    };
    this.cache[beltNumber] = cachedItem;
    return cachedItem.userProfiles;
  }
}
